<template>
  <div>
    <v-card tile flat class="my-5">
      <v-card-text class="pa-0">
        <v-row no-gutters>
          <v-col cols="2">
            <div class="bg-kiri"></div>
          </v-col>
          <v-col cols="10" class="pa-5">
            <h1 class="headline info--text"> <strong>Instruksi</strong> Pemeriksaan </h1>
            <div>
              Berikan penilaian pada kandidat berikut ini.
            </div>
            <v-row dense no-gutters class="my-3">
              <v-col cols="12" md="5">
                <v-card flat outlined>
                  <v-card-text class="py-0">
                    <v-list>
                      <v-list-item class="px-0">
                        <v-list-item-avatar color="secondary">
                          <v-icon dark>mdi-account</v-icon>
                        </v-list-item-avatar>
                        <v-list-item-content class="py-0">
                          <div class="black--text subtitle-2">
                            {{ $getDeepObj(initValue, 'ptk.nama') || '-' }}
                          </div>
                          <div class="caption">
                            <div style="line-height: 1rem">
                              <v-icon small class="mb-1 mr-2">mdi-label-outline</v-icon>
                              {{ $getDeepObj(initValue, 'ptk.email') || '-' }}
                            </div>
                            <div>
                              <v-icon small class="mb-1 mr-2">mdi-office-building</v-icon>
                              {{ $getDeepObj(initValue, 'sekolah.nama') || '-' }}
                            </div>
                          </div>
                        </v-list-item-content>
                      </v-list-item>
                    </v-list>
                  </v-card-text>
                </v-card>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
    <v-card class="mx-auto container">
      <v-row class="px-0">
        <v-col cols="12">
          <v-toolbar flat>
            <v-toolbar-title class="display-1">Rubrik Penilaian</v-toolbar-title>
            <v-spacer />
            <v-btn v-if="false" color="blue" dark @click="onPanduan">
              <v-icon left>mdi-alert-circle</v-icon>
              PANDUAN PENILAIAN
            </v-btn>
          </v-toolbar>
        </v-col>
      </v-row>
      <v-divider></v-divider>
      <v-card v-for="item in rubriks" outlined class="mt-3" :key="item.k_pelatihan_rubrik_psp">
        <v-card-text>
          <v-row>
            <v-col cols="12" md="6">
              <div class="blue--text body-1">
                <strong>{{ item.keterangan }}</strong>
                <v-spacer></v-spacer>
              </div>
              <div class="black--text my-2">
                {{ $getDeepObj(item, 'konfig.deskripsi') }}
              </div>
            </v-col>
            <v-col cols="12" md="6">
              <div>
                <div class="black--text"><strong>Penilaian</strong></div>
                Berapa total kriteria yang terpenuhi berdasarkan jawaban kandidat ini?
              </div>
              <div>
                <div class="radio-outline mx-0">
                  <v-btn
                    small
                    :outlined="skor !== form[item.k_pelatihan_rubrik_psp]"
                    color="orange"
                    :class="['mr-1', skor === form[item.k_pelatihan_rubrik_psp] ? 'white--text' : '']"
                    v-for="skor in (item && item.konfig && item.konfig.opsi) || []"
                    :key="skor"
                    @click="onChangeNilai(item, skor)"
                  >
                    {{ skor }}
                  </v-btn>
                </div>
              </div>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-card>
  </div>
</template>
<script>
export default {
  props: {
    initValue: {
      type: Object,
      default: () => {},
    },
    rubriks: {
      type: Array,
      default: () => [],
    },
    mode: {
      type: String,
      default: 'form',
    },
  },
  data() {
    return {
      form: {},
      skoring: [0, 1, 2, 3, 4, 5],
    };
  },
  methods: {
    initForm(value) {
      const nilais = this.$getDeepObj(value, 'psp_pelatihan_kelas_nilais.0.psp_pelatihan_kelas_rubriks') || [];

      if (nilais.length) {
        nilais.forEach((item) => {
          this.$set(this.form, item.k_pelatihan_rubrik_psp, item.nilai);
        });
      }
    },

    reset() {
      this.$set(this, 'form', {});
    },

    getValue() {
      return this.form || {};
    },

    onChangeNilai(item, skor) {
      if (this.mode !== 'form') return;
      this.form[item.k_pelatihan_rubrik_psp] = skor;
    },
  },
  watch: {
    initValue: 'initForm',
  },
};
</script>
<style scoped>
.bg-kiri {
  background: #bbdefb;
  height: 100%;
}
</style>
